//Drag Label is a variant of H5P's DragQuestion.
//This interactive allows the user to drag labels onto dropzones overlaid an an image.
//Also referred to as Drag Label to Image.
import Container from './container'
export default Container
